import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { searchConstants } from '../../search-utils/searchConstants';
import { updateType, search } from '../../state/actions';
import { StateType } from '../../../state/state.types';
import { SearchTypes } from '../../search.types';

const mapState = ({ queryParams, results, layout, user }: StateType) => {
  const enhanceType = (type: { key: SearchTypes; labelId: string }) => {
    const isSelectedSearchType = queryParams.type === type.key;
    const count = results.counts[type.key] || 0;

    const url = `/search?q=${results.query}&type=${type.key}`;
    const countOverride = count > Math.floor(count);
    return {
      key: type.key,
      labelId: type.labelId,
      url,
      countOverride,
      count,
      selected: isSelectedSearchType,
    };
  };
  const types = searchConstants.types.map(enhanceType);
  const hasQuery = results.query.length > 0;
  const isSearchOpened =
    hasQuery && layout.userHasStartedToSearch && !user.trialExpired;
  return {
    types,
    isSearchOpened,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onTypeChanged(type: SearchTypes) {
    dispatch(updateType(type));
    dispatch(search({ reason: 'type_changed' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
